import { Link } from "react-router-dom";
import { Users, ChevronRight, Crown, Globe } from "lucide-react";

export const TournamentCard = ({ t, index }) => (
  <Link
    to={`/tournament/${t.id}`}
    data-testid={`tournament-card-${t.id}`}
    className="card-surface p-4 sm:p-6 block group hover:border-emerald-500/60 hover:-translate-y-0.5 fade-up"
    style={{ animationDelay: `${index * 60}ms` }}
  >
    <div className="flex items-start justify-between gap-3">
      <span className="font-mono text-[10px] uppercase tracking-widest text-emerald-400">{t.competition_name}</span>
      {t.visibility === "public" && (
        <span className="flex items-center gap-1 text-[10px] font-mono uppercase text-sky-400" data-testid={`tournament-public-badge-${t.id}`}><Globe size={12} /> Pubblico</span>
      )}
      {t.is_admin && (
        <span className="flex items-center gap-1 text-[10px] font-mono uppercase text-amber-400"><Crown size={12} /> Admin</span>
      )}
    </div>
    <h3 className="font-display text-xl sm:text-2xl font-bold uppercase tracking-tight mt-2 sm:mt-3 truncate">{t.name}</h3>
    <div className="flex items-center justify-between mt-3 sm:mt-6 text-sm text-slate-400">
      <span className="flex items-center gap-1.5"><Users size={14} /> {t.members_count} {t.members_count === 1 ? "giocatore" : "giocatori"}</span>
      <ChevronRight size={18} className="text-slate-500 group-hover:text-emerald-400 group-hover:translate-x-1 transition-transform" />
    </div>
  </Link>
);
